/* eslint no-underscore-dangle: 0 */

export const config = {
	SEARCH_TYPE_INSTRUMENT: 'Search instrument',
	SEARCH_TYPE_TRADE: 'trade',
	SEARCH_TYPE_INFO: 'Instrument info',
	SEARCH_DEFAULT_FILTER: 'All',
	SEARCH_NO_INSTRUMENT: 'No instrument'
};

export function trackSearch(searchObj) {
	try {
		// TODO: digital data object would be removed once Analytics 2 is finalized
		const { _satellite, digitalData, adobeDataLayer } = window;
		if (_satellite && digitalData) {
			digitalData.search = searchObj;
			_satellite.track && _satellite.track('dynamicPricingWidget');
		}
		if (adobeDataLayer) {
			const componentViewed = {
				componentInfo: {
					componentId: '', // LIST id of component
					componentType: 'pricing-widget'
				},
				measures: {
					impression: '1' // since component is in view already
				},
				dynamicPricingWidgetInfo: {
					// if the component is the dynamic pricing widget, these fields should be populated
					dynamicPricingWidgetAsset: searchObj.asset,
					dynamicPricingWidgetInstrument: searchObj.instrument,
					dynamicPricingWidgetTerm: searchObj.term,
					dynamicPricingWidgetType: searchObj.type
				}
			};
			adobeDataLayer.push({ event: 'componentViewed', ...componentViewed });
		}
	} catch (error) {
		console.error(`${error.name} : ${error.message}`);
	}
}
